import { motion } from 'framer-motion';
import { useGameStore } from '@stores/gameStore';

/**
 * Crash history display
 * Shows recent crash multipliers with color coding
 */
export function CrashHistory(): React.JSX.Element {
  const { crashHistory } = useGameStore();

  if (crashHistory.length === 0) {
    return <div />;
  }

  return (
    <div className="pointer-events-auto flex flex-wrap justify-center gap-2 rounded-lg bg-aviator-skyDark/60 p-2 backdrop-blur-sm">
      {crashHistory.slice(0, 10).map((crash, index) => {
        // Color based on crash value
        let bgColor = 'bg-aviator-danger/40';
        let textColor = 'text-aviator-danger';

        if (crash >= 10) {
          bgColor = 'bg-purple-500/40';
          textColor = 'text-purple-400';
        } else if (crash >= 5) {
          bgColor = 'bg-orange-500/40';
          textColor = 'text-orange-400';
        } else if (crash >= 2) {
          bgColor = 'bg-aviator-success/40';
          textColor = 'text-aviator-success';
        }

        return (
          <motion.div
            key={`${crash}-${index}`}
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ delay: index * 0.05 }}
            className={`rounded-md px-2 py-1 text-xs font-bold ${bgColor} ${textColor}`}
          >
            {crash.toFixed(2)}x
          </motion.div>
        );
      })}
    </div>
  );
}
